// extracted by mini-css-extract-plugin
export default {"title":"Z4-z","warning":"_4-z","sizeOptionsLegendText":"a5-z"};